import type { TransactionEnvelope } from "@saberhq/solana-contrib";
import type { PublicKey } from "@solana/web3.js";

export interface PendingTransferAndWrapper {
  mint: PublicKey;
  transferWrapper: PublicKey;
  tx: TransactionEnvelope;
}
